import { render, staticRenderFns } from "./CoreIndividualCard.vue?vue&type=template&id=0e71dee5"
import script from "./CoreIndividualCard.vue?vue&type=script&lang=js"
export * from "./CoreIndividualCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports